import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AppsService } from "src/app/shared/services/apps.service";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import { FormBuilder, FormGroup, FormControl, FormArray } from "@angular/forms";
import moment from "moment";
import { differenceInCalendarDays } from "date-fns";
import * as L from "leaflet";
import { Router } from "@angular/router";
import { NzMessageService } from "ng-zorro-antd/message";

// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeExcelCell } from "src/app/shared/utils/sanitize-export";

@Component({
  selector: "app-trips-dashboard",
  templateUrl: "./trips-dashboard.component.html",
  styleUrls: ["./trips-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TripsDashboardComponent implements OnInit {
  /** Stable bound reference for <app-data-grid [cellPrepared]>. */
  bound_onCellPrepared = (e: any) =>
    this.onCellPrepared(this.tripsDatacolumnDefs, e);

  header_label = {
    name: "Daily Trips",
  };
  trnsfrPntsCvrdDta: any;
  trnsfrPntsCvrdcolumnDefs;
  trnsfrPntsNtCvrdDta: any;
  trnsfrPntsNtCvrdcolumnDefs;
  dateFormat = "dd-MM-yyyy";
  monthFormat = "yyyy/MM";
  selectedValue = null;
  showLdr = true;
  vehCtgrys;
  postslctdDt;
  wghmnts = false;
  selectedCtgry = 0;
  slctdDt = new Date();
  curDate;
  curTblDate;
  rteDta;
  rdCnts;
  vehTrpLst: any;
  clntDtls: any;
  today = new Date();
  routemap: any = [];
  route_Polyline: any = [];
  tntLst: any = [];
  selectedtenant;
  currentDate;
  selectedVehicle = 0;
  selectedTrip;
  vehTrpLstMsg;
  selectedvndr;
  vendorList;
  ttl_veh;
  visible = false;
  trpSldrvisible = false;
  vhclSldrvisible = false;
  driverSldrVisible = false;
  selectedDriverForSlider: any = null;
  filterPanelOpen = true;
  tripSearchText: string = "";
  trpsdata;
  tripsDatacolumnDefs;
  clap_in: any;
  userDtls: any;
  ShowClap: boolean;
  wghmntForm: FormGroup;

  /**
   * Get count of completed/travelled trips
   * Completed trips are those that have both actual start and end times recorded
   */
  get completedTripsCount(): number {
    if (!this.trpsdata || this.trpsdata.length === 0) return 0;
    // Filter trips that are completed/travelled - have both start and end times
    return this.trpsdata.filter((trip: any) => {
      // A trip is considered completed if it has both actual start and end timestamps
      return (
        trip.actl_strt_ts &&
        trip.actl_end_ts &&
        trip.actl_strt_ts.trim() !== "" &&
        trip.actl_end_ts.trim() !== ""
      );
    }).length;
  }
  isStandalone: boolean = false;
  constructor(
    public apiServ: AppsService,
    public TransfereService: TransfereService,
    public route: Router,
    private message: NzMessageService
  ) {
    this.isStandalone = this.route.url.includes("trips-dashboard");
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    this.selectedtenant = 0;
    this.currentDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
      this.selectedvndr = 0;
    } else {
      this.ShowClap = false;
      this.selectedvndr = 0;
    }
  }
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, this.today) > 0;
  };

  ngOnInit() {
    this.wghmntForm = new FormGroup({
      veh_nu: new FormControl(""),
      grs_wght: new FormControl(""),
      tr_wght: new FormControl(""),
      nt_wght: new FormControl(""),
    });
    this.slctdDt = new Date();
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.curTblDate = moment(this.slctdDt).format("DD-MM-YYYY");

    // Initialize column definitions to make data grid visible
    this.tripsDatacolumnDefs = [
      {
        headerName: "S.No",
        field: "sno",
        alignment: "center",
        width: 80,
        filter: false,
        cellClass: "pm-grid-number-cell",
        search: false,
      },
      {
        headerName: "Vehicle Registration Number",
        alignment: "center",
        width: 130,
        field: "asrt_nm",
        cellClass: "pm-grid-number-cell",
      },
      {
        headerName: "Ownership",
        alignment: "center",
        width: 80,
        field: "ownership_nm",
        cellClass: "pm-grid-number-cell",
      },
      {
        headerName: "Vehicle Category",
        field: "asrt_ctgry_nm",
        alignment: "center",
        cellClass: "pm-grid-number-cell",
        filter: true,
        width: "auto",
      },
      {
        headerName: "Sachivalayam",
        alignment: "center",
        width: 130,
        field: "svm_nm",
        cellClass: "pm-grid-number-cell",
      },
      {
        headerName: "Driver",
        alignment: "center",
        field: "crw_nm",
        cellClass: "pm-grid-number-cell",
        width: "auto",
        hide: true,
      },
      {
        headerName: "Trip No.",
        field: "trp_sqnc_nu",
        width: 80,
        alignment: "center",
        cellClass: "pm-grid-number-cell",
      },
      {
        headerName: "Trip Type",
        field: "trp_typ_nm",
        alignment: "center",
        cellClass: "pm-grid-number-cell",
        filter: true,
        width: "auto",
      },
      {
        headerName: "From",
        alignment: "center",
        field: "strt_fnce_nm",
        cellClass: "pm-grid-number-cell",
        width: "auto",
      },
      {
        headerName: "To",
        field: "end_fnce_nm",
        alignment: "center",
        cellClass: "pm-grid-number-cell",
        width: "auto",
      },
      {
        headerName: "Actual Start",
        alignment: "center",
        field: "actl_strt_ts",
        cellClass: "pm-grid-number-cell",
        width: "auto",
      },
      {
        headerName: "Actual End",
        field: "actl_end_ts",
        alignment: "center",
        cellClass: "pm-grid-number-cell",
        width: "auto",
      },
      {
        headerName: "Trip Status",
        field: "trp_status",
        alignment: "center",
        cellClass: "pm-grid-number-cell",
        width: "auto",
      },
      {
        headerName: "Travelled Distance",
        alignment: "center",
        field: "actl_trvl_dstne_ct",
        cellClass: "pm-grid-number-cell",
        width: "auto",
      },
      {
        headerName: "Travelled Time",
        field: "actl_trvl_tm",
        alignment: "center",
        cellClass: "pm-grid-number-cell",
        width: "auto",
      },
      {
        headerName: "Route Deviation",
        field: "rt_dev",
        alignment: "center",
        cellClass: "pm-grid-number-cell",
        width: "auto",
      },
      {
        headerName: "Vehicle Status",
        field: "asrt_sts_nm",
        alignment: "center",
        cellClass: "pm-grid-number-cell",
        width: "auto",
      },
    ];
    this.trpsdata = [];

    this.get_vehCategories();
    this.get_vehCategories();
    this.getVendors(this.selectedtenant);
    this.get_totalVehiclesData();
    this.searchTrips();
  }

  searchTrips() {
    this.get_TripsData(
      this.currentDate,
      this.selectedtenant,
      this.selectedvndr,
      this.selectedCtgry,
      this.selectedVehicle
    );
  }

  getSldr(evnt) {
    console.log(evnt);
    if (evnt.rowType == "data" && evnt.column.dataField == "trp_sqnc_nu") {
      console.log("Trippp");
      this.selectedTrip = evnt.data;
      this.trpSldrvisible = true;
    } else if (evnt.rowType == "data" && evnt.column.dataField == "asrt_nm") {
      console.log("Vehicle");
      this.selectedVehicle = evnt.data;
      this.vhclSldrvisible = true;
    } else if (
      evnt.rowType == "data" &&
      evnt.column.dataField == "crw_nm" &&
      evnt.data.crw_id
    ) {
      console.log("Driver");
      this.selectedDriverForSlider = evnt.data;
      this.driverSldrVisible = true;
    } else if (
      evnt.rowType == "data" &&
      evnt.column.dataField == "ply_ln_oprtn"
    ) {
      if (evnt.data.ply_ln_oprtn == "Edit") {
        this.editPolyline(evnt.data);
      } else {
        this.addPolyline(evnt.data);
      }
    }
  }
  editPolyline(data) {
    console.log("editable polyline");
  }
  addPolyline(data) {
    console.log("add new  polyline");
  }
  ontntSelect(value) {
    // Reset vehicle selection when tenant changes
    this.selectedVehicle = 0;

    if (value == 0) {
      this.selectedtenant = 0;
    } else {
      for (let i = 0; i < this.tntLst.length; i++) {
        if (this.tntLst[i].tnt_id == value) {
          this.selectedtenant = this.tntLst[i].tnt_id;
          break;
        }
      }
    }

    // Reset category when tenant changes
    this.selectedCtgry = 0;

    // Get vendors for selected tenant, which will trigger vehicle and trip data refresh
    this.getVendors(this.selectedtenant);
  }
  getVendors(slctTnt?) {
    this.showLdr = true;
    this.postslctdDt = {
      tnt_in: 1,
      slctd_tnt: slctTnt || this.selectedtenant,
    };
    console.log("Fetching vendors for tenant:", this.postslctdDt);
    let rte = `dashboard/enterprise/getVhclewise_vendorlst`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.showLdr = false;
          this.vendorList = res["data"] || [];
          console.log("Vendors fetched:", this.vendorList);

          // Set default vendor
          if (this.vendorList.length > 1) {
            this.selectedvndr = 0;
          } else if (this.vendorList.length === 1) {
            this.selectedvndr = this.vendorList[0].vndr_id;
          } else {
            this.selectedvndr = 0;
          }

          // Reset category and fetch vehicles and trips for selected tenant
          this.selectedCtgry = 0;
          this.get_totalVehiclesData();
        }
      },
      (err) => {
        console.error("Error fetching vendors:", err);
        this.showLdr = false;
        this.vendorList = [];
        this.selectedvndr = 0;
        // Still try to get vehicles and trips even if vendor fetch fails
        this.get_totalVehiclesData();
      }
    );
  }
  onvndrSelect(value) {
    console.log("Vendor selected:", value);
    this.selectedvndr = value || 0;
    // Reset vehicle selection when vendor changes
    this.selectedVehicle = 0;
    // Fetch vehicles and trips for selected vendor
    this.get_totalVehiclesData();
  }

  onChange(e): void {
    // console.log('onChange: ',e);
    this.selectedCtgry = 0;
    this.slctdDt = e;
    // console.log('slctdDt: ', this.slctdDt);
    this.currentDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.curTblDate = moment(this.slctdDt).format("DD-MM-YYYY");

    // console.log(this.currentDate);
    this.selectCategory(0, this.currentDate);
    this.get_vehCategories();
  }

  get_vehCategories(): any {
    this.showLdr = true;
    this.apiServ.get(`dashboard/enterprise/get_vehCtgrys`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          if (res_data) {
            this.vehCtgrys = res["data"];
            // console.log(this.vehCtgrys);
            this.selectedCtgry = 0;
          }
          this.showLdr = false;
        }
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  selectCategory(evnt, dt?, vehID?) {
    console.log("Category selected:", evnt);
    this.selectedCtgry = evnt || 0;
    // Reset vehicle selection when category changes
    this.selectedVehicle = 0;
    // Fetch vehicles and trips for selected category
    this.get_totalVehiclesData();
  }
  selectVehicle(evnt) {
    console.log("Vehicle selected:", evnt);
    this.selectedVehicle = evnt || 0;
  }
  get_totalVehiclesData() {
    this.showLdr = true;
    this.ttl_veh = [];

    this.postslctdDt = {
      dt: this.currentDate,
      selectedtenant: this.selectedtenant || 0,
      selectedctgry: this.selectedCtgry || 0,
      // If clap_in is 0, always use vendor id as 0
      selectedvndr: this.clap_in == 0 ? 0 : this.selectedvndr || 0,
      tnt_in: 1,
    };
    console.log("Fetching vehicles for tenant:", this.postslctdDt);
    const rte = `dashboard/enterprise/total_vehicles`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          if (res_data) {
            this.ttl_veh = res["data"] || [];
            console.log(
              "Vehicles fetched for selected tenant:",
              this.ttl_veh.length,
              "vehicles"
            );
            this.showLdr = false;

            // If vehicle was previously selected but is not in the new list, reset it
            if (this.selectedVehicle && this.selectedVehicle !== 0) {
              const vehicleExists = this.ttl_veh.some(
                (v: any) => v.asrt_id === this.selectedVehicle
              );
              if (!vehicleExists) {
                console.log(
                  "Previously selected vehicle not found in new list, resetting selection"
                );
                this.selectedVehicle = 0;
              }
            }

            // Avoid auto-fetching trips data here, wait for search button
          } else {
            this.ttl_veh = [];
            this.showLdr = false;
          }
        } else {
          this.ttl_veh = [];
          this.showLdr = false;
        }
      },
      (err) => {
        console.error("Error fetching vehicles:", err);
        this.ttl_veh = [];
        this.showLdr = false;
      }
    );
  }
  get_TripsData(dt?, ulb?, vndr?, ctgry?, vhcl?) {
    // Use provided parameters or fall back to component properties
    const selectedDate = dt || this.currentDate;
    const selectedTenant = ulb !== undefined ? ulb : this.selectedtenant;
    // If clap_in is 0, always use vendor id as 0
    const selectedVendor =
      this.clap_in == 0 ? 0 : vndr !== undefined ? vndr : this.selectedvndr;
    const selectedCategory = ctgry !== undefined ? ctgry : this.selectedCtgry;
    const selectedVehicle = vhcl !== undefined ? vhcl : this.selectedVehicle;

    console.log("Fetching trips data:", {
      date: selectedDate,
      tenant: selectedTenant,
      vendor: selectedVendor,
      category: selectedCategory,
      vehicle: selectedVehicle,
    });

    this.showLdr = true;
    this.postslctdDt = {
      dt: selectedDate,
      selectedtenant: selectedTenant || 0,
      selectedctgry: selectedCategory || 0,
      selectedvndr: selectedVendor || 0,
      asrtId: selectedVehicle || 0,
    };

    const rte = `dashboard/enterprise/get_tdyFltrTripDetails`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          if (res_data) {
            this.trpsdata = res["data"] || [];
            console.log(
              "Trips fetched:",
              this.trpsdata.length,
              "trips for selected filters"
            );

            // Process trip data
            this.trpsdata.forEach((k: any) => {
              if (k["ply_sts"] == 1) {
                k["ply_ln_oprtn"] = "Edit";
              } else {
                k["ply_ln_oprtn"] = "Add";
              }
              // Set ownership name based on asrt_ownr_id
              k["ownership_nm"] =
                k["asrt_ownr_id"] == 2 ? "Contract Vehicle" : "Own Vehicle";
              // Set driver ownership (crw_own_in) if not present - default to 1 (Own) if not specified
              if (k["crw_own_in"] === undefined || k["crw_own_in"] === null) {
                k["crw_own_in"] = 1; // Default to Own driver if not specified
              }
            });

            this.showLdr = false;
            this.tripsDatacolumnDefs = [
              {
                headerName: "S.No",
                field: "sno",
                alignment: "center",
                width: 80,
                filter: false,
                cellClass: "pm-grid-number-cell",
                search: false,
              },
              {
                headerName: "Vehicle Registration Number",
                alignment: "left",
                width: 140,
                field: "asrt_nm",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: "Ownership",
                alignment: "center",
                width: 80,
                field: "ownership_nm",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: "Vehicle Category",
                field: "asrt_ctgry_nm",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                filter: true,
                width: "auto",
              },
              {
                headerName: "Sachivalayam",
                alignment: "left",
                width: 130,
                field: "svm_nm",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: "Driver",
                alignment: "left",
                field: "crw_nm",
                cellClass: "pm-grid-number-cell",
                width: "auto",
                hide: true,
              },
              {
                headerName: "Trip No.",
                field: "trp_sqnc_nu",
                width: 80,
                alignment: "center",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: "Trip Type",
                field: "trp_typ_nm",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                filter: true,
                width: "auto",
              },
              {
                headerName: "From",
                alignment: "left",
                field: "strt_fnce_nm",
                cellClass: "pm-grid-number-cell",
                width: 300,
              },
              {
                headerName: "To",
                field: "end_fnce_nm",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                width: 300,
              },
              {
                headerName: "Actual Start",
                alignment: "right",
                field: "actl_strt_ts",
                cellClass: "pm-grid-number-cell",
                width: 150,
              },
              {
                headerName: "Actual End",
                field: "actl_end_ts",
                alignment: "right",
                cellClass: "pm-grid-number-cell",
                width: 150,
              },
              {
                headerName: "Trip Status",
                field: "trp_status",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                width: "auto",
              },
              {
                headerName: "Travelled Distance",
                alignment: "center",
                field: "actl_trvl_dstne_ct",
                cellClass: "pm-grid-number-cell",
                width: 130,
              },
              {
                headerName: "Travelled Time",
                field: "actl_trvl_tm",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                width: 130,
              },
              {
                headerName: "Route Deviation",
                field: "rt_dev",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                width: "auto",
              },
              {
                headerName: "Vehicle Status",
                field: "asrt_sts_nm",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                width: "auto",
              },
            ];
          } else {
            this.trpsdata = [];
            this.showLdr = false;
            console.log("No trips data returned");
          }
        } else {
          this.trpsdata = [];
          this.showLdr = false;
          console.log("Failed to fetch trips data");
        }
      },
      (err) => {
        console.error("Error fetching trips data:", err);
        this.trpsdata = [];
        this.showLdr = false;
      }
    );
  }

  gotoPlaybck(event) {
    let tripData;
    if (event && event.row && event.row.data) {
      tripData = event.row.data;
    } else if (event && event.data) {
      tripData = event.data;
    }

    if (tripData) {
      console.log("event: ", tripData);
      // Store trip data for tracking component
      this.TransfereService.setLoclData("plybckDta", tripData);
      if (tripData.actl_strt != undefined && tripData.actl_end != undefined) {
        // Navigate to tracking page instead of play-back page
        this.route.navigate([`internal/tracking/list`]);
      } else {
        this.message.create("error", "Trip data is not available for playback");
      }
    }
  }

  onCellPrepared(colDef, e) {
    if (e.rowType === "data" && e.row.data) {
      // Highlight vehicle column
      if (e.column.dataField === "asrt_nm") {
        e.cellElement.style.color = "#2563eb";
        e.cellElement.style.fontWeight = "600";
        e.cellElement.style.cursor = "pointer";
        e.cellElement.style.textDecoration = "underline";
        e.cellElement.title = "Click to view vehicle dashboard";
      }

      // Highlight driver column
      if (e.column.dataField === "crw_nm" && e.data.crw_id) {
        e.cellElement.style.color = "#2563eb";
        e.cellElement.style.fontWeight = "600";
        e.cellElement.style.cursor = "pointer";
        e.cellElement.style.textDecoration = "underline";
        e.cellElement.title = "Click to view driver dashboard";
      }
    }

    // Polyline edit/add styling
    if (colDef.length && colDef.length > 0) {
      colDef.filter((o) => {
        if (o.field == "ply_ln_oprtn") {
          if (e.data && (e.displayValue == "Edit" || e.displayValue == "Add")) {
            e.cellElement.style.color = "rgb(21 101 192);";
            e.cellElement.style.fontWeight = 500;
            e.cellElement.style.borderRadius = "10px";
            e.cellElement.style.background = "rgb(222 234 247)";
            e.cellElement.style.backgroundClip = "content-box";
            e.cellElement.style.cursor = "pointer";
          }
        }
      });
    }
  }
  goToSchduleIntrfc() {
    const returnUrl = this.route.url;
    this.route.navigate([`internal/schedule-trips/addtrip`], {
      queryParams: { returnUrl },
    });
  }
  goToprimaryTrps() {
    const returnUrl = this.route.url;
    this.route.navigate([`internal/schedule-trips/svm-trip`], {
      queryParams: { returnUrl },
    });
  }
  eachVehData;
  addWghmnt(data) {
    this.showLdr = false;
    console.log(data);
    this.eachVehData = data.data;
    this.wghmnts = true;
    this.wghmntForm.get("veh_nu").setValue(data.data.asrt_nm);
    this.get_TripsData();
  }
  closervrlst() {
    this.wghmnts = false;
    this.wghmntForm.reset();
    this.showLdr = false;
  }
  createMessage(type: string, msg: string): void {
    this.message.create(type, msg);
  }

  calculate() {
    var veh_dtls = this.wghmntForm.value;
    var result = veh_dtls.grs_wght - veh_dtls.tr_wght;
    if (result > 0) {
      this.wghmntForm.get("nt_wght").setValue(result);
    } else {
      this.createMessage(
        "warning",
        "Gross Weight should be greater than Tare Weight"
      );
    }
  }

  updateWeighmnt() {
    var veh_dtls = this.wghmntForm.value;
    var grss_wt = veh_dtls.grs_wght;
    var tar_wt = veh_dtls.tr_wght;
    var net_wt = grss_wt - tar_wt;
    var postData = {
      asrt_id: this.eachVehData.asrt_id,
      trp_rn_id: this.eachVehData.trp_rn_id,
      grs_wt: grss_wt,
      tr_wt: tar_wt,
      nt_wt: net_wt,
    };
    console.log(postData);
    if (net_wt > 0 && grss_wt > tar_wt) {
      this.apiServ
        .post(postData, `dashboard/enterprise/wghmnt_dtls`)
        .subscribe((res) => {
          if (res["status"] == 200) {
            this.createMessage("Success", "Weighments added successfully");
          }
        });
    } else {
      // console.log(net_wt,grss_wt,tar_wt)
      this.createMessage(
        "warning",
        "Gross Weight should be greater than Tare Weight"
      );
    }
  }

  // onExporting() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.
}
